import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLiveRef, useOnceShowup } from '@/hooks';
import { fetchNFTTokenDetail } from '@/utils';
import classnames from 'classnames';
import { memo, useCallback, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { MediaViewer, MediaViewerSkeleton } from '../MediaViewer';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
export const NFTItem = ({ className, contractName, token, sold, disabled, hoverEffect = true, ...rest }) => {
    const t = useLocales();
    const ref = useRef(null);
    const [tokenMeta, setVerboseToken] = useState({
        name: token.name,
        image: token.image ?? '',
    });
    const liveRef = useLiveRef();
    const fetchDetail = useCallback(async () => {
        if (!token.tokenURI) {
            return;
        }
        const meta = await fetchNFTTokenDetail(token.tokenURI);
        if (liveRef.current) {
            setVerboseToken(meta);
        }
    }, [token.tokenId, token.tokenURI]);
    useOnceShowup(ref, fetchDetail);
    return (_jsxs("div", { className: classnames(styles.nft, className, disabled ? styles.disabled : null, hoverEffect ? styles.hoverEffect : null), title: `${tokenMeta.name} #${token.tokenId}`, ...rest, ref: ref, children: [_jsx(MediaViewer, { className: styles.media, name: tokenMeta.name, image: tokenMeta.image, animationUrl: tokenMeta.animation_url }), _jsxs("div", { className: styles.info, children: [contractName && _jsx("h3", { className: styles.contractName, children: contractName }), _jsx("h3", { className: styles.name, children: tokenMeta.name || `#${token.tokenId}` }), sold !== undefined && (_jsx("h3", { className: styles.saleStatus, children: sold ? t('Sold') : t('For Sale') }))] }), sold && _jsx("div", { className: styles.mask })] }));
};
export const NFTItemSkeleton = memo(({ className, sold, ...rest }) => {
    return (_jsxs("div", { className: classnames(styles.nft, className), ...rest, children: [_jsx("div", { className: styles.media, children: _jsx(MediaViewerSkeleton, { className: styles.media }) }), _jsxs("div", { className: styles.info, children: [_jsx("h3", { className: styles.contractName, children: _jsx(Skeleton, { width: "50%" }) }), _jsx("h3", { className: styles.name, children: _jsx(Skeleton, { width: "40px" }) }), sold !== undefined && (_jsx("h3", { className: styles.saleStatus, children: _jsx(Skeleton, { width: "20px" }) }))] })] }));
});
